import { DropdownChooserItem } from '../../typings/common';

import {
    CreativeGroupOptions,
    CreativeOptionData,
    CreativeOptionGroupName,
    CreativeOptionsData,
    CreativeOptionType,
    CreativePositionOptionValue
} from './typings';

export function getAgeItems(values: string[]): DropdownChooserItem[] {
    return values.map((value: string) => {
        return {
            id: value,
            name: `+${value}`
        };
    });
}

export function getSelectItems(values: string[]): DropdownChooserItem[] {
    return values.map((value: string) => {
        return {
            id: value,
            name: value
        };
    });
}

export function getPositionValues(values: string[]): CreativePositionOptionValue[] {
    return values.reduce((acc: CreativePositionOptionValue[], value: string) => {
        switch (value) {
            case CreativePositionOptionValue.LeftTop:
            case CreativePositionOptionValue.CenterTop:
            case CreativePositionOptionValue.RightTop:
            case CreativePositionOptionValue.LeftCenter:
            case CreativePositionOptionValue.CenterCenter:
            case CreativePositionOptionValue.RightCenter:
            case CreativePositionOptionValue.LeftBottom:
            case CreativePositionOptionValue.CenterBottom:
            case CreativePositionOptionValue.RightBottom:
                acc.push(value);
                return acc;
            default:
                return acc;
        }
    }, []);
}

export function optionGroupVisible(options: CreativeOptionData[], values: CreativeGroupOptions): boolean {
    return options.some(option => {
        // если visible или editable в параметре не указаны, то по умолчанию они true
        const visible = option.visible === undefined ? true : option.visible;
        const editable = option.editable === undefined ? true : option.editable;

        if (!visible) {
            return false;
        }

        const hasValue = values[option.name] !== undefined && values[option.name] !== '';

        // если параметр не редактируемый и никакого значения в нем нет, то он скрыт
        return editable || hasValue;
    });
}

export function getOptionConfig(
    options: CreativeOptionsData,
    group: CreativeOptionGroupName,
    type: CreativeOptionType
): CreativeOptionData | undefined {
    return options.optionsConfig[group].options.find(option => option.type === type);
}
